import { render, staticRenderFns } from "./RequestForm.vue?vue&type=template&id=4edb383b&scoped=true"
import script from "./RequestForm.vue?vue&type=script&lang=ts"
export * from "./RequestForm.vue?vue&type=script&lang=ts"
import style0 from "./RequestForm.vue?vue&type=style&index=0&id=4edb383b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edb383b",
  null
  
)

export default component.exports